import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Iconslink2 icon
 *
 * @category Files/Forms/Editing
 */
const Iconslink2 = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M18.237 20.364c-1.692-.013-3.82-.797-4.94-2.19-.61-.834-.125-1.42.92-.697 5.003 3.944 8.425.024 11.897-3.56 5.637-6.321-3.72-13.489-9.01-7.142-.547.647-1.965 1.418-1.866.522.324-1.17 2.277-2.663 3.397-3.36C23.663.914 30.507 5.68 28.94 11.467c-.46 1.791-1.381 2.874-2.775 4.205-2.228 2.178-4.343 4.704-7.69 4.692h-.237"
        />
        <path
          fill="currentColor"
          d="M9.788 29c-5.961.05-9.309-7.292-5.015-11.623 1.518-1.48 3.098-3.273 4.853-4.517 2.55-1.742 6.234-1.556 8.549.473 1.418 1.281.597 2.165-.834.945-4.169-3.198-7.715-.236-10.64 2.95-2.999 2.264-3.646 6.993-.36 9.345 1.99 1.518 4.815 1.518 6.844.1.92-.573 1.742-1.73 2.787-2.277.523-.262.946.074.647.634-1.344 2.09-4.131 3.982-6.62 3.97z"
        />
      </svg>
    );
  }
);

Iconslink2.displayName = 'Iconslink2';

export { Iconslink2 };
